import React, { useState } from "react";
import styles from "./contact.module.css";
import Header from "../Header/Header";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from "@mui/material/styles";
import { FormControl, TextField } from "@mui/material";
import AccountDetails from "./AccountDetails";
import ContactDetails from "./ContactDetails";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";

const Android12Switch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-track": {
    borderRadius: 16,
    height: 24,
    backgroundColor: theme.palette.grey[300],
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 300,
    }),
  },
  "& .MuiSwitch-thumb": {
    width: 20,
    height: 20,
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    backgroundColor: "#fff",
  },
  "&.Mui-checked": {
    "& .MuiSwitch-thumb": {
      backgroundColor: theme.palette.primary.main,
    },
    "& .MuiSwitch-track": {
      backgroundColor: theme.palette.primary.light,
      opacity: 1,
    },
  },
  width: 56,
  height: 40,
  padding: 8,
  "& .MuiSwitch-switchBase": {
    padding: 10,
    "&.Mui-checked": {
      transform: "translateX(16px)",
    },
  },
}));

const CreateContact = () => {
  const [checkedPayout, setCheckedPayout] = useState(false); // State for Payout switch
  const [checkedCollect, setCheckedCollect] = useState(false); // State for Collect switch
  const [pan, setPan] = useState("");
  const [name, setName] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [phoneNumbers, setPhoneNumbers] = useState([{ value: "", error: "" }]);
  const [email, setEmail] = useState([{ value: "", error: "" }]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState("contractDetails");
  const navigate = useNavigate();

  // Handle change for a specific phone number field
  const handlePhoneChange = (index, value) => {
    const updatedPhoneNumbers = [...phoneNumbers];
    updatedPhoneNumbers[index].value = value;
    setPhoneNumbers(updatedPhoneNumbers);
  };
  const handleMailChange = (index, value) => {
    const updatedMail = [...email];
    updatedMail[index].value = value;
    setEmail(updatedMail);
  };
  const handleBlur = (index, type) => {
    if (type === "phone") {
      const updatedPhoneNumbers = [...phoneNumbers];
      updatedPhoneNumbers[index].error = validateField(
        "number",
        updatedPhoneNumbers[index].value
      );
      setPhoneNumbers(updatedPhoneNumbers);
    } else if (type === "email") {
      const updatedEmails = [...email];
      updatedEmails[index].error = validateField(
        "email",
        updatedEmails[index].value
      );
      setEmail(updatedEmails);
    }
  };
  // Add a new phone number field
  const addPhoneField = () => {
    setPhoneNumbers([...phoneNumbers, { value: "", error: "" }]);
  };

  const addMailField = () => {
    setEmail([...email, { value: "", error: "" }]);
  };

  const handlePayoutChange = (event) => {
    setCheckedPayout(event.target.checked);
  };

  const handleCollectChange = (event) => {
    setCheckedCollect(event.target.checked);
  };

  const validateField = (field, value) => {
    let errorMessage = "";
    switch (field) {
      case "pan":
        if (!value.trim()) errorMessage = "PAN is required.";
        else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i.test(value.trim()))
          errorMessage = "PAN must be in a valid format (ABCDE1234F)";
        break;
      case "number":
        if (!value.trim()) errorMessage = "Phone number is required";
        else if (!/^\d{10}$/.test(value.trim()))
          errorMessage = "Phone number must be 10 digits";
        break;
      case "email":
        if (!value.trim()) errorMessage = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()))
          errorMessage = "Invalid email format";
        break;
      default:
        break;
    }
    return errorMessage;
  };

  const handleSubmit = async () => {
    const errors = {};

    // Validate all fields
    errors.pan = validateField("pan", pan);
    errors.name = !name.trim() ? "Name is required" : "";

    phoneNumbers.forEach((phone, index) => {
      errors[`phone${index}`] = validateField("number", phone.value);
    });

    email.forEach((mail, index) => {
      errors[`email${index}`] = validateField("email", mail.value);
    });

    setFieldErrors(errors);

    // Check if there are any errors
    if (Object.values(errors).every((error) => !error)) {
      const contactData = {
        name,
        pan,
        payout: checkedPayout,
        collect: checkedCollect,
        phoneNumbers: phoneNumbers.map((p) => p.value),
        emails: email.map((e) => e.value),
      };

      // Add API call here
      console.log("Form data:", contactData);
      // await api.createContact(contactData);
    }
  };

  const goToAccDetails = async () => {
    const errors = {
      pan: validateField("pan", pan),
      name: !name.trim() ? "Name is required" : "",
    };

    setFieldErrors(errors);

    if (Object.values(errors).every((error) => !error)) {
      setPage("accountDetails");
    }
  };

  const removePhoneField = (index) => {
    setPhoneNumbers(phoneNumbers.filter((_, i) => i !== index));
  };
  const removeMailField = (index) => {
    setEmail(email.filter((_, i) => i !== index));
  };

  const handleBackClick = () => {
    if (page === "accountDetails") {
      setPage("contractDetails");
    } else if (page === "viewDetails") {
      setPage("accountDetails");
    } else {
      navigate("/contact");
    }
  };

  return (
    <div>
      {/* <Header /> */}
      {/* <div className={`${styles.title} mt-5`}>{"Hello, " + ""}</div>
      <div className={`${styles.welcomeToThe}`}>
        Welcome to the world of digital escrow
      </div> */}
      <button
        className="mt-3 d-flex align-items-center gap-2 border-0 bg-transparent"
        onClick={handleBackClick}
      >
        <img src="./arrow-left.svg" alt="Back Arrow" />
        <span>Back</span>
      </button>
      <div className="d-flex justify-content-center align-items-center gap-2">
        <div>
          <span
            className={clsx(
              styles.header,
              page === "contractDetails" ? styles.textBlue : styles.textGrey
            )}
          >
            {"01 "}
          </span>
          <span
            className={
              page === "contractDetails" ? styles.textBlue : styles.textGrey
            }
          >
            {" "}
            {`Contract Details`}
          </span>
        </div>
        <div>{"----"}</div>
        <div>
          <span
            className={clsx(
              styles.header,
              page === "accountDetails" ? styles.textBlue : styles.textGrey
            )}
          >
            {"02 "}
          </span>
          <span
            className={
              page === "accountDetails" ? styles.textBlue : styles.textGrey
            }
          >{`Account Details`}</span>
        </div>
        <div>{"----"}</div>
        <div>
          <span
            className={clsx(
              styles.header,
              page === "viewDetails" ? styles.textBlue : styles.textGrey
            )}
          >
            {"03 "}
          </span>
          <span
            className={
              page === "viewDetails" ? styles.textBlue : styles.textGrey
            }
          >{`View Details`}</span>
        </div>
      </div>
      {page === "contractDetails" ? (
        <>
          {" "}
          <div className={`${styles.title} mt-2`}>
            {"Enter Contact Details"}
          </div>
          <div className="d-flex align-items-center gap-3">
            <FormControlLabel
              label="Payout"
              labelPlacement="start" // Label before switch
              control={
                <Android12Switch
                  checked={checkedPayout}
                  onChange={handlePayoutChange}
                />
              }
            />
            <FormControlLabel
              label="Collect"
              labelPlacement="start" // Label before switch
              control={
                <Android12Switch
                  checked={checkedCollect}
                  onChange={handleCollectChange}
                />
              }
            />
          </div>
          <div className="d-flex gap-1">
            <FormControl className="w-50">
              <TextField
                label="Contact Name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                variant="outlined"
                onBlur={() =>
                  setFieldErrors((prev) => ({
                    ...prev,
                    pan: validateField("contact", name),
                  }))
                }
                error={!!fieldErrors.pan}
                helperText={fieldErrors.pan}
              />
            </FormControl>
            <FormControl className="w-50">
              <TextField
                label="PAN"
                required
                value={pan}
                onChange={(e) => setPan(e.target.value)}
                variant="outlined"
                onBlur={() =>
                  setFieldErrors((prev) => ({
                    ...prev,
                    pan: validateField("pan", pan),
                  }))
                }
                error={!!fieldErrors.pan}
                helperText={fieldErrors.pan}
              />
            </FormControl>
            <div className="d-flex align-items-center mx-2">
              <button
                type="button"
                style={{
                  backgroundColor: "#2348AB",
                  color: "#FFFFFF",
                  borderRadius: "8px",
                }}
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                {"Verify"}
              </button>
            </div>
          </div>
          <div className="d-flex w-100 gap-3">
            <div className="w-50">
              <div className={`${styles.title} mt-2 mb-2`}>
                {"Phone Number"}
              </div>
              <div>
                {phoneNumbers.map((phone, index) => (
                  <div key={index}>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className={`${styles.title} mt-2 mb-2`}>{`${
                        index + 1
                      }. Phone Number`}</div>
                      {index > 0 && (
                        <div
                          className="text-danger cursor-pointer"
                          onClick={() => removePhoneField(index)}
                        >
                          Remove
                        </div>
                      )}
                    </div>
                    <div>
                      <FormControl className="w-100">
                        <TextField
                          label={`Phone Number ${index + 1}`}
                          value={phone.value}
                          onChange={(e) =>
                            handlePhoneChange(index, e.target.value)
                          }
                          variant="outlined"
                          onBlur={() => handleBlur(index)}
                          error={!!phone.error}
                          helperText={phone.error}
                        />
                      </FormControl>
                    </div>
                  </div>
                ))}
                <button
                  className={`mt-2 ${styles.loadsButtons} `}
                  onClick={addPhoneField}
                >
                  <img
                    className={`${styles.arrowNarrowLeftIcon} mx-1`}
                    alt=""
                    src="/pluscircle3.svg"
                  />
                  <b className={styles.addDirector}>Add More Ph no</b>
                </button>
              </div>
            </div>
            <div className="w-50">
              <div className={`${styles.title} mt-2 mb-2`}>
                {"Email Address"}
              </div>
              <div className="mt-2">
                {email.map((mail, index) => (
                  <div key={index}>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className={`${styles.title} mt-2 mb-2`}>{` ${
                        index + 1
                      }. Email ID`}</div>
                      {index > 0 && (
                        <div
                          className="text-danger cursor-pointer"
                          onClick={() => removeMailField(index)}
                        >
                          Remove
                        </div>
                      )}
                    </div>
                    <div>
                      <FormControl className="w-100">
                        <TextField
                          label={`Email ID ${index + 1}`}
                          value={mail.value}
                          onChange={(e) =>
                            handleMailChange(index, e.target.value)
                          }
                          variant="outlined"
                          onBlur={() => handleBlur(index)}
                          error={!!mail.error}
                          helperText={mail.error}
                        />
                      </FormControl>
                    </div>
                  </div>
                ))}
                <button
                  className={`mt-2 ${styles.loadsButtons} `}
                  onClick={addMailField}
                >
                  <img
                    className={`${styles.arrowNarrowLeftIcon} mx-1`}
                    alt=""
                    src="/pluscircle3.svg"
                  />
                  <b className={styles.addDirector}>Add More emails</b>
                </button>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <button
              type="button"
              style={{
                backgroundColor: "#2348AB",
                color: "#FFFFFF",
                borderRadius: "8px",
              }}
              className="btn btn-primary mt-4 px-5 "
              onClick={goToAccDetails}
            >
              {"Save & Next"}
            </button>
          </div>
        </>
      ) : page === "accountDetails" ? (
        <AccountDetails setPage={setPage} />
      ) : page === "viewDetails" ? (
        <ContactDetails />
      ) : (
        ""
      )}
    </div>
  );
};

export default CreateContact;
